import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CoinInfo } from '../../context/coin_context'

export interface TotalsByCoinRow {
    label: string
    value: string
}

export interface TotalsByCoinItem {
    coin: CoinInfo
    rows: TotalsByCoinRow[]
}

interface Props {
    title?: string
    totals: TotalsByCoinItem[]
}

export function TotalsCardByCoin({ title = 'Totais', totals }: Props) {
    const { t } = useTranslation()

    return (
        <Stack
            width="100%"
            mt="15px"
            border="1px solid var(--border-color)"
            borderRadius="12px"
            overflow="hidden"
            boxShadow="0 1px 3px rgba(16, 24, 40, 0.06), 0 4px 12px rgba(16, 24, 40, 0.04)"
        >
            <Box
                sx={{
                    px: '16px',
                    py: '10px',
                    backgroundColor: 'rgba(79, 70, 229, 0.08)',
                    borderBottom: '1px solid rgba(79, 70, 229, 0.15)',
                }}
            >
                <Typography fontWeight={700} fontSize="14px" color="#33408F">
                    {title}
                </Typography>
            </Box>
            <Stack direction="row" flexWrap="wrap">
                {totals.map((item) => (
                    <Stack
                        key={item.coin.id ?? item.coin.name}
                        flex="1 1 240px"
                        minWidth="240px"
                        p="14px 16px"
                        borderRight="1px solid var(--border-soft)"
                        sx={{
                            '&:last-child': { borderRight: 'none' },
                        }}
                    >
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing="8px"
                            mb="8px"
                        >
                            {item.coin.pathImage && (
                                <Box
                                    component="img"
                                    src={`/flags/${item.coin.pathImage}`}
                                    width="22px"
                                    height="22px"
                                    sx={{ objectFit: 'contain', borderRadius: '50%', }}
                                />
                            )}
                            <Typography fontWeight={700} fontSize="14px">
                                {item.coin.name}
                            </Typography>
                        </Stack>
                        <Stack spacing="5px">
                            {item.rows.map((row) => (
                                <Stack
                                    key={row.label}
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography
                                        fontSize="12px"
                                        color="text.secondary"
                                    >
                                        {row.label}
                                    </Typography>
                                    <Typography
                                        fontSize="13px"
                                        fontWeight={700}
                                        sx={{ wordBreak: 'break-word' }}
                                    >
                                        {row.value}
                                    </Typography>
                                </Stack>
                            ))}
                        </Stack>
                    </Stack>
                ))}
                {!totals.length && (
                    <Typography
                        fontSize="13px"
                        color="text.secondary"
                        p="14px 16px"
                        width="100%"
                        textAlign="center"
                    >
                        {t('Sem valores para exibir')}
                    </Typography>
                )}
            </Stack>
        </Stack>
    )
}
